import { useMutation } from '@tanstack/react-query';

import { Axios } from '@app/web-components';

const ELIGIBILITY_ALL_QUERY_KEY = 'ELIGIBILITIES_ALL_QUERY_KEY';
const RESOURCE_URL = '/eligibilities';

export const eligibilityKeys = {
  all: [ELIGIBILITY_ALL_QUERY_KEY] as const,
  lists: () => [...eligibilityKeys.all, 'list'] as const,
  list: (filters: object) => [...eligibilityKeys.lists(), filters] as const,
};

export const useStartPullEligibilitiesForBundle = () => {
  const axios = Axios.useAxiosApi();

  return useMutation({
    mutationFn: async (bundleId: number) =>
      axios.post(`${RESOURCE_URL}/start-pull-eligibilities-for-bundle`, { bundleId }),
  });
};

export const useStartPullEligibiliesForSubscriptionAccess = () => {
  const axios = Axios.useAxiosApi();

  return useMutation({
    mutationFn: async (subscriptionAccessId: number) =>
      axios.post(`${RESOURCE_URL}/start-pull-eligibilities-for-subscription-access`, { subscriptionAccessId }),
  });
};
